import { TanStackRootProvider } from './providers/tanstack/root-provider'
import { FrontendErrorBoundary } from '@/shared/monitoring/frontend-error-boundary'
import { FrontendErrorListeners } from '@/shared/monitoring/frontend-error-listeners'

function App() {
  return (
    <FrontendErrorBoundary>
      <FrontendErrorListeners />
      <TanStackRootProvider />
    </FrontendErrorBoundary>
  )
}

export { App }
